<template>
  <layout transition="scale-transition">
    <template slot="header">
      Program settings
    </template>

    <template>
      <v-form>
        <div class="px-4">
          <v-select
            :menu-props="{ bottom: true, offsetY: true }"
            data-test-theme
            v-model="findEl('programTheme').value"
            :items="themes"
            label="Theme"
          >
            <template v-slot:item="{ item: i }">
              <div :data-test-select-value="`${i.value}`">
                {{ i.text }}
              </div>
            </template>
          </v-select>
        </div>
        <div class="px-4">
          <v-select
            :menu-props="{ bottom: true, offsetY: true }"
            data-test-lang
            v-model="findEl('programLanguage').value"
            :items="languages"
            label="Language"
          >
            <template v-slot:item="{ item: i }">
              <div :data-test-select-value="`${i.value}`">
                {{ i.text }}
              </div>
            </template>
          </v-select>
        </div>
        <div class="px-4">
          <v-select
            :menu-props="{ bottom: true, offsetY: true }"
            data-test-rows
            v-model="findEl('programNumbersOfRows').value"
            :items="[5, 10, 20, 50, 100, 200, 500, 1000]"
            label="Default number of rows in table"
          >
            <template v-slot:item="{ item: i }">
              <div :data-test-select-value="`${i}`">
                {{ i }}
              </div>
            </template>
          </v-select>
        </div>
        <div class="px-4 mb-2 d-flex align-center">
          <div style="font-size: 16px">Show server time</div>
          <v-spacer />
          <v-switch
            data-test-switch="um"
            class="ma-0 py-3"
            hide-details
            v-model="findEl('programShowCoreTime').value"
          ></v-switch>
        </div>
      </v-form>
    </template>
    <template slot="footer">
      <v-spacer />
      <v-btn text color="text-primary" @click.stop="close">
        Cancel
      </v-btn>
      <v-btn text color="primary" depressed :loading="false" @click.stop="save">
        Save
      </v-btn>
    </template>
  </layout>
</template>

<script>
import Layout from '@/layouts/LayoutPopup';
import { ref, onMounted } from '@vue/composition-api';
import useAuth from '@/api/auth';
import useObjects from '@/api/objects';
export default {
  name: 'ProgramSettings',
  props: ['show'],
  components: { Layout },
  setup(props, context) {
    const { profile } = useAuth();
    let properties = ref([
      {
        key: 'programNumbersOfRows',
        value: ''
      },
      {
        key: 'programLanguage',
        value: 'en'
      },
      {
        key: 'programTheme',
        value: 'classic'
      },
      {
        key: 'programShowCoreTime',
        value: false
      }
    ]);

    const themes = [
      { id: 0, text: 'System', value: 'system' },
      { id: 1, text: 'Classic', value: 'classic' },
      { id: 2, text: 'Dark', value: 'dark' }
    ];

    const isLoading = ref(false);

    const languages = [
      { id: 1, text: 'English', value: 'en' },
      { id: 2, text: 'Russian', value: 'ru' },
      { id: 3, text: 'Chinese', value: 'cn' },
      { id: 4, text: 'Thai', value: 'th' }
    ];

    const close = () => {
      context.emit('close');
    };

    const saveHandler = () => {
      window.location.reload();
    };

    const { object } = useObjects();
    function save() {
      let propertiesSend = properties.value.map(el => ({
        value: el.value,
        propertyId: el.id
      }));
      isLoading.value = true;
      object
        .updateObjectPropertiesNoCache({
          propertiesArray: propertiesSend
        })
        .then(() => {
          saveHandler();
        })
        .finally(() => {
          isLoading.value = false;
        });
    }

    function findEl(key) {
      return properties.value.find(el => el.key === key);
    }

    onMounted(() => {
      properties.value = profile.value.objectProperties
        .filter(item => item.groupName === 'Program')
        .map(item => ({
          id: item.id,
          value: item.value,
          key: item.key
        }));
    });

    return {
      themes,
      close,
      saveHandler,
      save,
      languages,
      findEl,
      properties
    };
  }
};
</script>
